module.exports = __webpack_public_path__ + "img/plane-slash.063ce0fe.svg";